module.exports = __webpack_public_path__ + "static/media/montserrat-latin-700-normal.6324dc98.woff";